import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';
import SEOHead from '../components/SEOHead';

export default function NotFound() {
  const { language } = useLanguage();
  const basePath = language === 'en' ? '/en' : '';

  return (
    <div data-testid="not-found-page">
      <SEOHead
        title={language === 'nl' ? 'Pagina niet gevonden | Kesult' : 'Page not found | Kesult'}
        description={language === 'nl' ? 'Deze pagina bestaat niet.' : 'This page does not exist.'}
        lang={language}
      />
      <section className="min-h-[70vh] flex items-center justify-center bg-white">
        <div className="text-center px-6">
          <p className="text-sm font-semibold text-[#4286F4] uppercase tracking-widest mb-4">404</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#08080A] mb-4" data-testid="not-found-title">
            {language === 'nl' ? 'Pagina niet gevonden' : 'Page not found'}
          </h1>
          <p className="text-[#555] text-lg mb-8 max-w-md mx-auto">
            {language === 'nl'
              ? 'De pagina die je zoekt bestaat niet of is verplaatst.'
              : 'The page you are looking for does not exist or has been moved.'}
          </p>
          <Link to={`${basePath}/`}>
            <button className="bg-[#4286F4] text-white font-semibold px-8 py-3.5 rounded-full hover:bg-[#3070d4] transition-colors inline-flex items-center gap-2" data-testid="not-found-home-btn">
              <ArrowLeft className="h-4 w-4" />
              {language === 'nl' ? 'Terug naar home' : 'Back to home'}
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
}
